module.exports = __webpack_public_path__ + "img/error.378f81da.svg";